/**
 * store/hooks.ts
 * desc: react-redux hooks pre-bound to the store's RootState / AppDispatch
 * note: converted components use these instead of the bare useSelector /
 *       useDispatch so selectors and thunks type-check against the real store
 */

import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from './index';

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
